// Utility file to store global temp data
// --------------------------------------------------------
const state = {
  currentInvitation: null
}
const getters = {
  currentInvitation: state => state.currentInvitation
}
const mutations = {
  setCurrentInvitation(state, invitation) {
    state.currentInvitation = invitation
  },
  removeCurrentInvitation(state) {
    state.currentInvitation = null
  }
}

export default {
  state,
  getters,
  mutations
}
